import React from 'react'
import NavMenu from './NavMenu'
import styles from './mainLayout.module.css';
import { useThemeContext } from '../../theme/ThemeContext';
import { CssBaseline, Stack, ThemeProvider } from '@mui/material';

type MainLayoutProps = {
  children?: React.ReactNode
};

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { theme } = useThemeContext()
  
  return (
    <ThemeProvider theme={theme}>
    <CssBaseline/>
    <div className={styles.root} style={ { height: 'inherit', backgroundColor: theme.palette.info.main }} translate="no">
      <NavMenu>
      <Stack className={styles.content}  style={ { height: 'inherit', paddingLeft: theme.spacing(3), paddingRight: theme.spacing(3), backgroundColor: theme.palette.info.main }}>
        <div style={theme.mixins.toolbar}/>
        {children}
      </Stack>
      </NavMenu>
    </div>
    </ThemeProvider>
  )
}

export default MainLayout
